import { Link } from 'react-router-dom';
import React from 'react';
import {
	getPropertyScopedNavItems,
	resolvePropertyPath,
} from './propertyScopedNavigation';

/**
 * @param {{
 *  activePath?: string,
 *  className?: string,
 *  hasTeam: boolean,
 *  propertyId?: string
 * }} props
 * @returns {JSX.Element | null}
 */
export default function PropertySubmenu(props) {
	if (!props.propertyId) {
		return null;
	}
	const propertyId = props.propertyId;

	return (
		<nav
			className={`flex flex-wrap items-center gap-1 ${
				props.className ?? ''
			}`.trim()}
		>
			{getPropertyScopedNavItems(props.hasTeam).map((item) => {
				const resolvedPath = resolvePropertyPath(item.path, propertyId);
				const isActive = props.activePath === resolvedPath;

				return (
					<Link
						className={
							isActive
								? 'inline-flex items-center rounded-md bg-theme-light text-black font-semibold px-2 py-2 border-b-2 border-theme no-underline'
								: 'inline-flex items-center rounded-md bg-transparent text-grey-700 hover:bg-grey-100 hover:text-black px-2 py-2 no-underline'
						}
						key={item.key}
						to={resolvedPath}
					>
						{item.label}
					</Link>
				);
			})}
		</nav>
	);
}
